module.exports = __webpack_public_path__ + "img/search.712c1d63.svg";